import React, { useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function MfaVerify() {
	const { verifyMfa } = useAuth();
	const location = useLocation();
	const navigate = useNavigate();
	
	const mfaToken  = location.state?.mfaToken;
	const firstName = location.state?.firstName;
	
	const [code, setCode] = useState("");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);
	
	// Guard — if someone navigates here directly with no state, send them back
	if (!mfaToken) {
		return (
			<div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8
			text-center border border-farm-tan/30
			dark:border-gray-700 max-w-sm mx-auto">
			<div className="text-5xl mb-4">⚠️</div>
			<h2 className="text-xl font-bold text-red-600 dark:text-red-400
			mb-2">
			Session Expired
			</h2>
			<p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
			Please start the sign-in process again.
			</p>
			<Link
			to="/login"
			className="text-farm-green dark:text-green-400 font-semibold
			hover:underline"
			>
			Back to sign in
			</Link>
			</div>
		);
	}
	
	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		setLoading(true);
		try {
			await verifyMfa(mfaToken, code);
			navigate("/order");
		} catch (err) {
			setError(
				err.response?.data?.error ||
				"Invalid code. Please try again."
			);
			setCode("");
		} finally {
			setLoading(false);
		}
	};
	
	return (
		<div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8
		border border-farm-tan/30 dark:border-gray-700
		max-w-sm mx-auto transition-colors duration-200">
		<div className="text-center mb-6">
		<div className="text-5xl mb-3">🔐</div>
		<h2 className="text-2xl font-bold text-farm-green dark:text-green-400">
		Two-Factor Auth
		</h2>
		{firstName && (
			<p className="text-gray-500 dark:text-gray-400 text-sm mt-1">
			Welcome, {firstName}! Enter the 6-digit code from your
			authenticator app.
			</p>
		)}
		</div>
		
		{error && (
			<div className="bg-red-50 dark:bg-red-900/30 border border-red-300
			dark:border-red-600 text-red-700 dark:text-red-300
			rounded-lg p-3 mb-4 text-sm">
			{error}
			</div>
		)}
		
		<form onSubmit={handleSubmit} className="space-y-4">
		<div>
		<label className="block text-sm font-medium text-gray-700
		dark:text-gray-300 mb-1">
		Authenticator Code
		</label>
		<input
		type="text"
		inputMode="numeric"
		autoComplete="one-time-code"
		required
		maxLength={6}
		value={code}
		onChange={(e) =>
			setCode(e.target.value.replace(/\D/g, "").slice(0, 6))
		}
		placeholder="000000"
		className="w-full border border-gray-300 dark:border-gray-600
		rounded-lg px-3 py-4 text-center text-3xl
		tracking-[0.5em] font-mono bg-white dark:bg-gray-700
		text-gray-800 dark:text-gray-100
		placeholder-gray-300 dark:placeholder-gray-600
		focus:outline-none focus:ring-2 focus:ring-farm-green"
		/>
		</div>
		
		<button
		type="submit"
		disabled={loading || code.length !== 6}
		className="w-full bg-farm-green text-white py-3 rounded-xl
		font-semibold hover:bg-green-700 transition-colors
		disabled:opacity-60"
		>
		{loading ? "Verifying…" : "Verify & Sign In"}
		</button>
		</form>
		
		<div className="mt-5 p-4 bg-gray-50 dark:bg-gray-700/50 rounded-xl
		border border-gray-200 dark:border-gray-600
		text-sm text-gray-600 dark:text-gray-400 space-y-1">
		<p className="font-medium text-gray-700 dark:text-gray-300">
		💡 Where to find your code
		</p>
		<p>
		Open your authenticator app (e.g. Google Authenticator, Authy,
									 or 1Password) and enter the current 6-digit code shown for
									 Cedar Fork Farm.
									 </p>
									 <p>Codes refresh every 30 seconds.</p>
									 </div>
									 
									 <p className="mt-4 text-center text-sm text-gray-500
									 dark:text-gray-400">
									 <Link
									 to="/login"
									 className="text-farm-green dark:text-green-400 hover:underline"
									 >
									 ← Use a different account
									 </Link>
									 </p>
									 </div>
	);
}
